import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "./AuthContext";
import LoginPopup from "./LoginPopup"

const PrivateRoute = ({ children }) => {
  const { token } = useContext(AuthContext);
  const [authorized, setAuthorized] = useState(false);
  const [checking, setChecking] = useState(false);
  const basePath = process.env.REACT_APP_BASE_PATH || "/";
  const baseUrl = basePath === "/" ? "/api" : `${basePath}/api`;

  useEffect(() => {
    if (!token) {
      setAuthorized(false);
      setChecking(false);
      return;
    }
    let cancelled = false;
    const run = async () => {
      setChecking(true);
      try {
        const res = await fetch(`${baseUrl}/auth-check`, {
          headers: { Authorization: token }
        });
        if (!cancelled) setAuthorized(res.ok);
      } catch (_) {
        if (!cancelled) setAuthorized(false);
      } finally {
        if (!cancelled) setChecking(false);
      }
    };
    run();
    return () => { cancelled = true; };
  }, [token, baseUrl]);

  if (!token) return <LoginPopup />;
  if (checking) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-lg text-gray-600">Signing you in...</div>
      </div>
    );
  }
  if (!authorized) return <LoginPopup />;
  return children;
};

export default PrivateRoute;
